import { createClient } from '@supabase/supabase-js'

// Ambiente seguro! Use .env.local e VITE_ prefix
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY

export const supabase = createClient(supabaseUrl, supabaseKey)